import React from 'react';

const MBAHealthManagement = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Executive Master of Business Administration in Health Care Management</h2>
        <p className="mb-4">
          The Executive Master of Business Administration (EMBA) in Health Care Management
          is a master's-level professional degree granted to students who complete a course of study in the
          knowledge and competencies needed for careers in healthcare administration, involving the
          management of hospitals and other health service organizations.
        </p>
        <p className="mb-4">
          The Executive Master of Business Administration in Health Care Management at
          Hamilton College of the Bahamas offers valuable experience and useful knowledge in a results
          oriented environment. Participants gain practical managerial skills to augment their talent as
          Health Care Managers. The program allows participants to continue working full-time while
          pursuing the degree, and to interact with peers from across the continent.
        </p>
        <p className="mb-4">
          The degree at Hamilton College of the Bahamas requires students to complete applied
          experiences as well as course work in areas such as population health, healthcare economics,
          health policy, organizational behavior, management of healthcare organizations, healthcare
          marketing and communications, human improvement, governance, leadership, statistical analysis
          and application, financial analysis and management, and strategy formulation and
          implementation.
        </p>
        <p className="mb-4">
          Utilizing our case-based teaching methods combined with extensive peer collaboration,
          the degree program keeps clinical executives on top of trends, issues and competitive strategies
          unique to the U.S. health care system.
        </p>
        <p className="mb-4">Thirty Six Credit Hours Required</p>
        
        <h2 className="text-2xl font-bold mb-4">Core Courses</h2>
        <p className="mb-4">(Six Courses - 18 Credit Hours)</p>
        <ul className="list-disc list-inside mb-4">
          <li>HCM 711: Principles of Health Care Management (3)</li>
          <li>HCM 755: Managing Health Service Organizations (3)</li>
          <li>HCM 704: Strategic Management of Health Care Organizations 1 (3)</li>
          <li>HCM 721: Financial Management of Hospital and Health Care Organizations (3)</li>
          <li>HCM 709: Health Care Management and Organization Design and Behavior (3)</li>
          <li>HCM 757: Cases in Health Care Service Management (3)</li>
        </ul>
        
        <h2 className="text-2xl font-bold mb-4">Elective Courses</h2>
        <p className="mb-4">(Select Six Courses - 18 Credit Hours)</p>
        <ul className="list-disc list-inside mb-4">
          <li>HCM 705: Strategic Management of Health Care Organizations 2 (3)</li>
          <li>HCM 722: Essentials of Health Care Finance (3)</li>
          <li>HCM 731: The Effective Care Supervisor (3)</li>
          <li>HCM 733: Working in Health Care (3)</li>
          <li>HCM 741: Legal Aspects of Health Information Systems (3)</li>
          <li>HCM 757: Directed Readings in Health Care Management (3)</li>
          <li>MBA 508: Research Methods in Business 1 (3)</li>
          <li>MBA 512: Business Communications 1 (3)</li>
          <li>MBA 530: Advanced Principles of Supervision 1 (3)</li>
          <li>MBA 531: Advanced Principles of Supervision 2 (3)</li>
          <li>MBA 532: Advanced Leadership Principles 1 (3)</li>
          <li>MBA 533: Advanced Leadership Principles 2 (3)</li>
          <li>MBA 573: Directed Readings in Management and Leadership (3)</li>
        </ul>
      </div>
    </div>
  );
};

export default MBAHealthManagement;